import { render, staticRenderFns } from "./imageCarousel.vue?vue&type=template&id=a7ad840e&"
import script from "./imageCarousel.vue?vue&type=script&lang=js&"
export * from "./imageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7ad840e')) {
      api.createRecord('a7ad840e', component.options)
    } else {
      api.reload('a7ad840e', component.options)
    }
    module.hot.accept("./imageCarousel.vue?vue&type=template&id=a7ad840e&", function () {
      api.rerender('a7ad840e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2YkRPyoZNC29E/JS/imageCarousel.vue"
export default component.exports